import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";

import { BaseComponent, ContentService, HelperService, UserService, WorkspaceService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { FirebaseService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-add-satellite-connection",
  templateUrl: "add-satellite-connection.component.html",
  standalone: false,
})
export class AddSatelliteConnectionComponent extends BaseComponent implements OnInit {
  public loading: boolean = false;
  public email: string;
  public foundUser: any;
  public noUser: boolean;
  public message: string;
  @Input() editing: any;
  @Output() connectionSaved: EventEmitter<any> = new EventEmitter();

  constructor(
    userService: UserService,
    public workspaceService: WorkspaceService,
    public activeModal: NgbActiveModal,
    private _router: Router,
    public helperService: HelperService,
    public contentService: ContentService,
    public fbService: FirebaseService
  ) {
    super(userService);
  }

  ngOnInit() {}

  submit() {
    if (this.helperService.validateEmail(this.email)) {
      this.loading = true;
      this.userService.searchUser(this.email).subscribe(
        (result) => {
          this.loading = false;
          if (result && result.user) {
            this.foundUser = result.user;
          }
        },
        (err) => {
          this.loading = false;
          this.noUser = true;
        }
      );
    } else {
      alert("Please enter a valid email.");
    }
  }

  invite() {
    this.loading = true;
    let emailNotificationArgs: any = {
      email: this.email,
      inviterName: this.user.firstName + " " + this.user.lastName,
      message: this.message,
    };
    if (this.foundUser) {
      emailNotificationArgs.user_has_account = true;
      let myArgs: any = {
        email: this.foundUser.email,
        status: "pending",
        initiatedBy: this.user.id,
        name: this.foundUser.firstName + " " + this.foundUser.lastName,
        userId: this.foundUser.id,
        photo: this.foundUser.photoURL,
      };
      if (this.message) myArgs.inviteMessage = this.message;
      let theirArgs: any = {
        email: this.user.email,
        status: "pending",
        initiatedBy: this.user.id,
        name: this.user.firstName + " " + this.user.lastName,
        userId: this.user.id,
        photo: this.user.photoURL,
      };
      if (this.message) theirArgs.inviteMessage = this.message;

      let myRef = this.fbService.doc(`user_profiles/${this.user.id}/linked_users/${this.foundUser.id}`);
      let theirRef = this.fbService.doc(`user_profiles/${this.foundUser.id}/linked_users/${this.user.id}`);
      this.fbService.updateDocument(`user_profiles/${this.foundUser.id}`, { linkedUsersTag: this.fbService.increment(1) }).then(() => {
        let promises = [myRef.set(myArgs), theirRef.set(theirArgs)];
        Promise.all(promises).then(() => {
          this.activeModal.close();
          this.connectionSaved.next(true);
          this.contentService.sendEmail(emailNotificationArgs, "notify_metro_connection_request").subscribe();
        });
      });
    } else {
      emailNotificationArgs.user_has_account = false;
      this.fbService
        .doc(`linked_user_invitations/${this.email}`)
        .set({
          initiatedBy: this.user.id,
          name: this.user.firstName + " " + this.user.lastName,
          photo: this.user.photoURL,
          message: this.message,
          email: this.user.email,
        })
        .then(() => {
          this.activeModal.close();
          this.connectionSaved.next(true);
          this.contentService.sendEmail(emailNotificationArgs, "notify_metro_connection_request").subscribe();
        })
        .catch(() => {});
    }
  }
}
